module.exports = __webpack_public_path__ + "img/Fraese.8235e06a.webp";